import { State, StateUpdateRequest } from "@bluefalcon/clients-management-client-fetch";
import { falconClients } from "../clients/falcon.client";

export class StateService {

    async getStates(): Promise<State[]> {
        return falconClients.states.getStates();
    }

    async updateStateById(id: string, request: StateUpdateRequest): Promise<State> {
        return falconClients.states.updateStateById({
            id,
            stateUpdateRequest: request,
        });
    }

    async getStateById(id: string): Promise<State> {
        return falconClients.states.getStateById({
            id,
        });
    }
}